module.exports = __webpack_public_path__ + "img/首页banner1.7c7d0c13.png";